import { defineMessages } from 'utils/intl';

export default defineMessages({
  copy: 'kopiuj',
  copyMessage: 'Treść została skopiowana.',
});
